module.exports = __webpack_public_path__ + "img/dsci0055.be47ebbf.jpg";